import { useTranslation } from 'react-i18next';
import { IconSize } from '../../constant/IconSize.constant';
import { PromotionStatusOption } from '../../hooks/usePromotion';
import { ComputedPromotionStatus } from '../../stores/types/promotions.interface';
import { getPromotionStatusLabel } from '../../utils/promotion.util';
import { ColorType, Dropdown, DropdownType, Label, LabelType, Pill } from '../_ui';
import InputSearch from '../_ui/InputSearch/InputSearch.component';

type Props = {
  searches: string[];

  // translated strings used in dropdown (NOT enum objects)
  statusOptions: PromotionStatusOption[];
  status: ComputedPromotionStatus[];

  onAddSearch: (v: string) => void;
  onRemoveSearch: (v: string) => void;

  onStatusChange: (items: PromotionStatusOption[]) => void;
  onRemoveStatus: (status: ComputedPromotionStatus) => void;

  onClearAll: () => void;

  numOfPills: number;
};

const PromotionFilters = ({
  searches,
  statusOptions,
  status,
  onAddSearch,
  onRemoveSearch,
  onStatusChange,
  onRemoveStatus,
  onClearAll,
  numOfPills,
}: Props) => {
  const { t } = useTranslation();

  const renderClearAllButton = () => {
    if (numOfPills === 0) return null;

    return (
      <div className='flex flex-row gap-4'>
        <button type='button' className='text-left' onClick={onClearAll}>
          <Label
            type={LabelType.DROPDOWN_ITEM_SELECTED}
            color={ColorType.DENIM}
            text={t('session_clear_all')}
          />
        </button>
      </div>
    );
  };

  return (
    <>
      {/* FILTER ROW */}
      <div className='flex flex-row justify-between'>
        <div className='flex gap-3'>
          <InputSearch
            width='280px'
            iconSize={IconSize.SIZE_24x24}
            inputIconPadding='pl-11'
            suffixIconClassName='mr-4'
            options={[]}
            onSelect={onAddSearch}
            placeholder={t('search_promotion_name')}
            contentDivWidth='w-[277px]'
            disabled={false}
            inputId='promotion-input-search'
          />

          <Dropdown
            placeholder={t('status')}
            placeholderLabelType={LabelType.DROPDOWN_HEADER}
            type={DropdownType.CHECKBOX}
            headerWidth='auto'
            items={statusOptions}
            onItemClick={onStatusChange}
            translationOn
            showFooter
            dataTestId='select-status'
            disabled={false}
            iconAlt={t('icon_alt_status_dropdown')}
          />
        </div>
      </div>

      {/* PILL ROW */}
      {numOfPills > 0 && (
        <div className='flex justify-between items-center mt-2'>
          <div className='flex gap-2 flex-wrap'>
            {/* search pills */}
            {searches.map((s) => (
              <Pill
                key={`search-${s}`}
                label={`"${s}"`}
                hasCloseButton
                onClick={() => onRemoveSearch(s)}
              />
            ))}

            {/* status pills */}
            {status.map((s) => (
              <Pill
                key={`status-${s}`}
                label={t(getPromotionStatusLabel(s))}
                hasCloseButton
                onClick={() => onRemoveStatus(s)}
              />
            ))}
          </div>

          {renderClearAllButton()}
        </div>
      )}
    </>
  );
};

export default PromotionFilters;
